import React from 'react'

export const UploadIconBlue = (props) => (
  <svg width={20} height={20} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M6.71 5.705 9 3.405v9.59a1 1 0 1 0 2 0v-9.59l2.29 2.3a1.004 1.004 0 0 0 1.42-1.42l-4-4a1.034 1.034 0 0 0-1.42 0l-4 4a1.004 1.004 0 0 0 1.42 1.42ZM19 9.995a1 1 0 0 0-1 1v6a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-6a1 1 0 0 0-2 0v6a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3v-6a1 1 0 0 0-1-1Z"
      fill="#2D54A4"
    />
  </svg>
)
